<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="headline">Cliente</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-text-field
            label="Descrizione"
            v-model="clientInfo.descrizione"
          ></v-text-field>

          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Email"
                v-model="clientInfo.mail"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Telefono"
                v-model="clientInfo.telefono"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12">
              <v-select
                label="Sede principale"
                :items="headquarters"
                item-text="fullAddress"
                item-value="idSede"
                v-model="clientInfo.idSedePrincipale"
              >
              </v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <!-- SEDE CLIENTE -->

      <v-data-table
        :headers="headers"
        :items="headquarters"
        class="elevation-1"
        item-key="indirizzo"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Sede Cliente</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>

            <v-dialog v-model="dialog" max-width="800px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  nuovo
                </v-btn>
              </template>
              <v-card>
                <FrmEditHeadquarter
                  ref="frmEditHeadquarter"
                  v-bind:headquarterDetails="editedHeadquarter"
                  v-on:headquarterAdded="headquarter_Added"
                ></FrmEditHeadquarter>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="dialog = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="frmEditHeadqurterSave_Click"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="700px">
              <v-card>
                <v-card-title class="headline"
                  >Are you sure you want to delete this
                  headquarter?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                    >OK</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>

        <v-snackbar v-model="ShowSnackbar" :timeout="5000">
          {{ error }}

          <template v-slot:action="{ attrs }">
            <v-btn color="blue" text v-bind="attrs" @click="error = ''">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-data-table>
      <!-- SEDE CLIENTE -->
    </v-card>
  </div>
</template>

<style>
</style>

<script>
import EasyPlanClient from "../../utils/EasyPlanClient";
import Map from "../CustomComponentsUI/Map";
import FrmEditHeadquarter from "../EditForms/FrmEditHeadquarter";
export default {
  components: { Map, FrmEditHeadquarter },
  props: ["clientInfo"],
  data: () => ({
    headers: [
      { text: "Indirizzo", value: "indirizzo" },
      { text: "CAP", value: "cap" },
      { text: "Città", value: "citta" },
      { text: "Provincia", value: "provincia" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    headquarters: [],
    editedIndex: -1,
    dialog: false,
    dialogHeadquarter: false,
    ShowSnackbar: false,
    dialogDelete: false,
    error: "",
    idSedePrincipale: null,
    //Errors: "",

    editedHeadquarter: {
      indirizzo: "",
      cap: "",
      citta: "",
      provincia: "",
    },
    defaultItem: {
      indirizzo: "",
      cap: "",
      citta: "",
      provincia: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Headquarter" : "Edit Headquarter";
    },

    Errors: {
      get() {
        if (
          this.editedHeadquarter.indirizzo != "" &&
          this.editedHeadquarter.città != "" &&
          this.editedHeadquarter.provincia != "" &&
          this.editedHeadquarter.cap != ""
        )
          return "Tutti i campi sono obbligatori";

        return "";
      },
    },
  },
  created() {
    if (this.clientInfo.idCliente != undefined) this.loadHeadquarters();
  },
  watch: {
    clientInfo(value) {
      if (value.idCliente != undefined) {
        this.loadHeadquarters();
      } else {
        this.headquarters = this.clientInfo.sedi; // [];
      }
    },
    idSedePrincipale(val) {
      this.clientInfo.idSedePrincipale = val;
    },
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },

    headquarters(val) {
      this.clientInfo.sedi = val;
    },
  },

  methods: {
    headquarter_Added() {
      this.save();
    },
    frmEditHeadqurterSave_Click: function () {
      this.$refs.frmEditHeadquarter.saveFrmEditCustomer();

      this.dialogHeadquarter = false;
      // $refs.frmEditHeadquarter.save
    },
    // initClientSaved() {},
    addClient: function (callback = () => {}) {
      if (this.clientInfo.idSedePrincipale != undefined) {
        console.debug(
          "this.clientInfo.idSedePrincipale",
          this.clientInfo.idSedePrincipale
        );
        EasyPlanClient.Customers.Insert(
          this.$route.params.companyAlias,
          this.clientInfo.descrizione,
          this.clientInfo.indirizzo,
          this.clientInfo.cap,
          this.clientInfo.città,
          this.clientInfo.provincia,
          this.clientInfo.telefono,
          this.clientInfo.mail,
          this.clientInfo.idSedePrincipale,
          this.headquarters
        )
          .then((res) => {
            callback(res.data.data);
            console.debug("risposta add customer:");
            console.debug(res);
            console.debug(res.data.data.idCliente);
            this.$emit("customerAdded", res.data.data);

            this.clientInfo.descrizione = "";
            this.clientInfo.indirizzo = "";
            this.clientInfo.cap = "";
            this.clientInfo.città = "";
            this.clientInfo.provincia = "";
            this.clientInfo.telefono = "";
            this.clientInfo.mail = "";
            this.headquarters = [];
          })
          .catch((error) => {
            console.log(error);
            this.error = EasyPlanClient.GetErrorDescription(
              error.response.data.errorCode
            );
            console.error(
              "si è verificato un errore (" +
                error.response.data.errorCode +
                ")" +
                this.error
            );
            console.error(error);
          });

        this.dialog = false;
      } else alert("Seleziona una sede per questo cliente");

      // var headquarter = this.headquarters.find((sede) => sede.idSede);

      // EasyPlanClient.Customers.Insert(
      //   this.$route.params.companyAlias,
      //   this.clientInfo.descrizione,
      //   this.clientInfo.indirizzo,
      //   this.clientInfo.cap,
      //   this.clientInfo.città,
      //   this.clientInfo.provincia,
      //   this.clientInfo.telefono,
      //   this.clientInfo.mail,
      //   headquarter.idSede,
      //   this.headquarters
      // )
      //   .then((res) => {

      //     console.debug("risposta add customer:");
      //     console.debug(res);
      //     console.debug(res.data.data.idCliente);
      //     this.$emit("customerAdded", res.data.data);

      //     this.clientInfo.descrizione = "";
      //     this.clientInfo.indirizzo = "";
      //     this.clientInfo.cap = "";
      //     this.clientInfo.città = "";
      //     this.clientInfo.provincia = "";
      //     this.clientInfo.telefono = "";
      //     this.clientInfo.mail = "";
      //     this.headquarters = [];
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //     this.error = EasyPlanClient.GetErrorDescription(
      //       error.response.data.errorCode
      //     );
      //     console.error(
      //       "si è verificato un errore (" +
      //         error.response.data.errorCode +
      //         ")" +
      //         this.error
      //     );
      //     console.error(error);
      //   });
    },
    getFullAddress(address, city, province) {
      let fullAddress = ""; //address + " - " + city + " (" + province + ") ";
      if (address != null) fullAddress += address;
      if (city != null) fullAddress += " - " + city;
      if (province != null) fullAddress += " (" + province + ")";

      return fullAddress;
    },
    editCustomer(customer, callback = () => {}) {
      EasyPlanClient.Customers.Update(this.$route.params.companyAlias, customer)
        .then((res) => {
          console.debug("risposta edit customer:");
          console.debug(res);
          
          res.data.data.fullAddress = this.getFullAddress(
            res.data.data.indirizzo,
            res.data.data.citta,
            res.data.data.provincia
          );
          callback(res.data.data);
          this.$emit("customerUpdated", res.data.data);
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },

    loadHeadquarters: function () {
      console.log("loading headquarters in FrmEditCustomer....");
      EasyPlanClient.Headquarters.GetAll(
        this.$route.params.companyAlias,
        this.clientInfo.idCliente
      )
        .then((res) => {
          for (let i = 0; i < res.data.data.length; i++) {
            res.data.data[i].fullAddress = this.getFullAddress(
              res.data.data[i].indirizzo,
              res.data.data[i].citta,
              res.data.data[i].provincia
            );
          }
          this.headquarters = res.data.data;

          console.log(this.headquarters, "headquarters");
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },

    editItem(item) {
      console.log("editing customers from editcustomer");
      this.editedIndex = this.headquarters.indexOf(item);
      this.editedHeadquarter = Object.assign({}, item);

      this.dialog = true;
    },

    deleteItem(item) {
      EasyPlanClient.Headquarters.Delete(
        this.$route.params.companyAlias,
        item.idCliente,
        item.idSede
      )
        .then((res) => {
          this.editedIndex = this.headquarters.indexOf(item);
          this.editedHeadquarter = Object.assign({}, item);
          this.dialogDelete = true;
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },

    deleteItemConfirm() {
      this.headquarters.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedHeadquarter = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedHeadquarter = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (
        this.editedHeadquarter.indirizzo != "" &&
        this.editedHeadquarter.citta != "" &&
        this.editedHeadquarter.provincia != "" &&
        this.editedHeadquarter.cap != ""
      ) {
        //this.Errors = "";
        if (this.editedIndex > -1) {
          this.editedHeadquarter.fullAddress = this.getFullAddress(
            this.editedHeadquarter.indirizzo,
            this.editedHeadquarter.citta,
            this.editedHeadquarter.provincia
          );
          // this.editEquipment(this.editedHeadquarter);
          Object.assign(
            this.headquarters[this.editedIndex],
            this.editedHeadquarter
          );
        } else {
          // this.insertHeadquarters(this.editedHeadquarter);
          this.editedHeadquarter.idSede = -1 * (this.headquarters.length + 1);
          this.editedHeadquarter.fullAddress = this.getFullAddress(
            this.editedHeadquarter.indirizzo,
            this.editedHeadquarter.citta,
            this.editedHeadquarter.provincia
          );
          this.headquarters.push(this.editedHeadquarter);

          // this.headquarterDetails.indirizzo = "",
          // this.headquarterDetails.cap = "",
          // this.headquarterDetails.citta = "",
          // this.headquarterDetails.provincia = ""
        }

        this.close();
      }
      //   else {
      //     this.Errors = "Tutti i campi sono obligatori";
      //   }
    },
  },
};
</script>

